<template>
  <div>
    <vs-popup
    class="holamundo"
    icon-close="X"
    :title="this.title"
    :active.sync="active"
    >
    <div class="content">
      <section class="section--sidebar-user">
        <section class="section--content-sidebar section--content-sidebar-full-height">
          <form
          method="POST"
          :action="this.action"
          accept-charset="UTF-8"
          enctype="multipart/form-data"
          class="workflow-tabs"
          >
          <input type="hidden" name="_token" :value="csrf" />
          <input
          v-if="this.editing"
          type="hidden"
          name="_method"
          value="PUT"
          />
          
          <div class="tab-content">
            
            <div class="row">
              <div class="col-12">
                <p class="tab-description mt-3 mb-2">Settings Ranking</p>
              </div>
            </div>
            
            <div class="row mb-3">
              <div class="col-12 col-md-4">
                <div class="form-group">
                  <label>{{__("forms.Question.title")}}</label>
                  <input type="text" class="form-control rounded" name="questionBase[name]" :value="this.name">
                </div>
              </div>
              <div class="col-12 col-md-4">
                <div class="form-group">
                  <label>{{__("forms.Question.description")}}</label>
                  <input type="text" class="form-control rounded" name="questionBase[description]" :value="this.description">
                </div>
              </div>
              <div class="col-12 col-md-4">
                <div class="form-group">
                  <label>{{__("forms.Question.sorting")}}</label>
                  <input type="number" class="form-control rounded" name="questionBase[sorting]" :value="this.sorting">
                </div>
              </div>
              <div class="col-12 col-md-4">
                <div class="form-group">
                  <label>Modalità di Calcolo</label>
                  <select class="form-control rounded" name="questionSettings[calculation]" required v-model="calculation">
                    <option value="">---</option>
                    <option value="odemSummary">Somma</option>
                    <option value="odemSimpleAverage">Media semplice</option>
                    <option value="odemAverage">Media delle medie</option>                  
                  </select>
                </div>
              </div>
            </div>
            
            <div class="row align-items-center mb-3">
              <div class="col-12 col-md-6">
                <div class="form-group">
                  <input
                  type="checkbox"
                  value="showing_results"
                  :name="'questionSettings[showing_main_results][]'"
                  v-model="showing_results"
                  />
                  <label> Mostra risultato finale</label>
                </div>
              </div>
              <div class="col-12 col-md-6">
                <div class="form-group">
                  <input
                  type="checkbox"
                  value="final_rating"
                  :name="'questionSettings[showing_main_results][]'"
                  v-model="final_rating"
                  />
                  <label> Mostra rating finale</label>
                </div>
              </div>
              <div class="col-12 col-md-6">
                <div class="form-group">
                  <input
                  type="checkbox"
                  value="1"
                  :name="'questionSettings[include_zero_value_in_operation]'"
                  v-model="include_zero_value_in_operation"
                  />
                  <label>Includi il valore di scala 0 nell'operazione. (valido solo per media semplice)</label>
                </div>
              </div>
              <div class="col-12"></div>
              <div class="col-12 col-md-6">
                <input
                type="checkbox"
                value="1"
                :name="'questionSettings[enable_expected_value]'"
                v-model="enable_expected_value"
                />
                <label>Abilita Valore atteso</label>
              </div>
              <div class="col-12 col-md-6">
                <label>Valore atteso</label>
                <input
                type="number" class="form-control"
                min="0" step="1"
                :name="'questionSettings[expected_value]'"
                v-model="expected_value"
                />
              </div>
              
            </div>
            
            
            <div class="row">
              <div class="col-12">
                <p class="tab-description mt-3 mb-2">Scala</p>
              </div>
            </div>
            
            <!-- old values -->
            <div class="row" v-for="(row, index) in scale" v-bind:key="'row'+index">
              <div class="col-3">
                <label><b>Valore</b></label>
                <input
                class="form-control"
                type="number"
                :name="'questionSettings[scale][' + index + '][value]'"
                required
                v-model="row.value"
                />
              </div>
              <div class="col-6 offset-3">
                <button type="button" class="btn btn--only-icon-rounded btn--danger float-right" @click="deleteScale(index)"><i class="fas fa-times"></i></button>
              </div>
              <div class="col-12">
                <!-- etichetta -->
                <div class="row">
                  <div class="col mt-1" v-for="(slug, id) in languages" v-bind:key="id">                                          
                    <label><b>Etichetta - {{slug}}</b></label>
                    <input
                    class="form-control"
                    type="text"
                    :name="'questionSettings[scale][' + index + '][label]['+slug+']'"
                    required
                    v-model="row.label[slug]"
                    />
                  </div> 
                </div>
                <!-- declaratoria -->
                <div class="row">
                  <div class="col mt-1" v-for="(slug, id) in languages" v-bind:key="id">
                    <label><b>Declaratoria  - {{slug}}</b></label>
                    <input
                    class="form-control"
                    type="text"
                    :name="
                    'questionSettings[scale][' + index + '][declaration]['+slug+']'
                    "
                    v-model="row.declaration[slug]"
                    />
                  </div>  
                </div>
              </div>
              
            </div>
            
            
            <div class="row mt-5">
              <div class="col-12">
                <p class="tab-description mt-3 mb-2">Aggiungi nuovo valore Scala</p>
              </div>
            </div>
            
            <div class="row">
              <div class="col-3">
                <label>Valore</label>
                <input
                class="form-control rounded"
                type="number"
                v-model="newScaleValue"
                />
              </div>
              <div class="col-6 offset-3"></div>
              <div class="col-12">
                <!-- etichetta -->
                <div class="row">
                  <div class="col mt-1" v-for="(slug, id) in languages" :key="'new_label'+id">
                    <label>Etichetta - {{slug}}</label>
                    <input
                    class="form-control"
                    type="text"
                    v-model="newScaleLabel[slug]"
                    />
                  </div>
                </div>
                <div class="row">
                  <div class="col mt-1" v-for="(slug, id) in languages" :key="'new_decla'+id">
                    <label>Declaratoria -  {{slug}}</label>
                    <input
                    class="form-control"
                    type="text"
                    v-model="newScaleDeclaration[slug]"
                    />
                  </div>
                </div>
              </div>
              <div class="col-12 mt-2">
                
                <button type="button" class="btn float-right" @click="addScale()">
                  Aggiungi Scala
                </button>
                
              </div>
              
            </div>
            
            
            
            <div class="row mt-5">
              <div class="col-12">
                <p class="tab-description mt-3 mb-2">Rating ( se X < index => Value)</p>
              </div>
            </div>
            
            
            <div class="row mb-3">
              <div class="col-12">
                <div class="row align-items-end mb-1" v-for="(row, index) in rating" v-bind:key="'rating_'+index">
                  
                  <div class="col">
                    <label><b>Indice</b></label>
                    <input
                    class="form-control rounded"
                    :name="
                    'questionSettings[rating][' + index + '][index]'
                    "
                    required
                    :value="row.index"
                    />
                  </div>
                  
                  <div class="col" v-for="(slug, id) in languages" v-bind:key="id" >
                    <label><b>Label - {{slug}}</b></label>
                    <input                            
                    class="form-control"
                    :name="
                    'questionSettings[rating][' + index + '][label]['+slug+']'
                    "
                    required
                    :value="row.label[slug]"
                    />
                  </div>
                  
                  <div class="col">
                    <button type="button" class="btn btn--only-icon-rounded btn--danger float-right" @click="deleteRating(index)"><i class="fas fa-times"></i></button>
                  </div>
                  
                </div>
              </div>
            </div>
            
            
            <div class="row mt-5">
              <div class="col-12">
                <p class="tab-description mt-3 mb-2">Aggiungi nuovo Rating</p>
              </div>
            </div>
            
            <div class="row align-items-end">
              <div class="col">
                
                <label><b>Nuovo indice</b></label>
                <input
                class="form-control rounded"
                type="number"
                v-model="newRatingIndex"
                />
                
              </div>
              <div class="col" v-for="(slug, id) in languages" v-bind:key="'new_rating'+id">
                <label><b>Nuova label  - {{slug}}</b></label>
                <input
                class="form-control"
                type="text"
                v-model="newRatingLabel[slug]"
                />
              </div>
              <div class="col">
                <button type="button" class="btn float-right" @click="addRating()">
                  Aggiungi rating
                </button>
              </div>
            </div>
            
            <div class="row mt-5">
              <div class="col-12">
                <p class="tab-description mt-3 mb-2">Categorie per proposte di sviluppo</p>
              </div>
            </div>
            
            <div class="row">
              <div class="col-3" v-for="(name, index) in allCategories" :key="'categories_'+index">
                <input
                type="checkbox"
                :value="index"
                :name="'questionSettings[categories][]'"
                :id="'questionSettings[categories][]' + index"
                v-model="categoriesProposals"
                />
                <label :for="'questionSettings[categories][]' + index"> {{ name }} </label>
              </div>
            </div>
            
            
            <div class="row mt-5">
              <div class="col-12">
                <p class="tab-description mt-3 mb-2">Livelli dinamici</p>
              </div>
            </div>
            
            <div class="row">
              <div class="col-3">
                <input
                type="checkbox"
                :value="1"
                :name="'questionSettings[showDynamicLevelFactorNote]'"
                :id="'questionSettings[showDynamicLevelFactorNote]'"
                v-model="showDynamicLevelFactorNote"
                />
                <label :for="'questionSettings[showDynamicLevelFactorNote]'">Mostra note</label>
              </div>
            </div>
            
            
            <div class="row">
              <div class="col-12">
                <hr>
              </div>
              <div class="col-12 mt-3 text-right" v-if="can_write">
                <button class="btn btn-next" type="submit">{{ __('misc.save') }}</button>
              </div>
            </div>
            
          </div>
        </form>
      </section>
    </section>
  </div>
</vs-popup>
</div>
</template>

<script>
export default {
  props: {
    can_write:{
      type:Boolean,
      required:true,
    }
  },
  data() {
    
    
    var newScaleLabelLang = [];        
    for(var i = 0; i < this.languages; i++){
      newScaleLabelLang[this.languages[i].slug];        
    }
    
    var newScaleDeclarationLang = [];
    for(var i = 0; i < this.languages; i++){
      newScaleDeclarationLang[this.languages[i].slug];        
    }
    
    var newRatingLabelLang = [];
    for(var i = 0; i < this.languages; i++){
      newRatingLabelLang[this.languages[i].slug];        
    }
    
    
    return {
      scale: [],
      rating: [],
      newRatingLabel: newRatingLabelLang,
      newRatingIndex: "",
      calculation: null,
      categoriesProposals: [],
      proposals: [],
      allProposals: [],
      allCategories: [],
      showing_results: false,
      final_rating: false,
      
      enable_expected_value: 0,
      expected_value: 0,
      
      newScaleValue: 0,
      newScaleLabel: newScaleLabelLang,
      newScaleDeclaration: newScaleDeclarationLang,
      showDynamicLevelFactorNote: 0,
      include_zero_value_in_operation: 0,
      actualSlugLang: "it",
      languages: ["it"],
      
      
      //default
      title: "ODEM",
      active: false,
      action: "",
      name: "",
      description: "",
      sorting: -1,
      editing: true,
      csrf: document
      .querySelector('meta[name="csrf-token"]')
      .getAttribute("content"),
    };
  },
  methods: {
    deleteRating(rowIndex) {
      Vue.delete(this.rating, rowIndex);
    },
    deleteScale(rowIndex) {
      Vue.delete(this.scale, rowIndex);
    },
    addRating() {
      let row = {
        index: this.newRatingIndex,
        label: this.newRatingLabel,
      };
      this.rating.push(row);
      
      this.newRatingIndex = 0;
      this.newRatingLabel = [];
      for(var i = 0; i < this.languages; i++){
        this.newRatingLabel[this.languages[i].slug];        
      }
    },
    addScale() {
      let row = {
        value: this.newScaleValue,
        label: this.newScaleLabel,
        declaration: this.newScaleDeclaration,
      };
      this.scale.push(row);
      
      this.newScaleValue = 0;
      this.newScaleLabel = [];
      for(var i = 0; i < this.languages; i++){
        this.newScaleLabel[this.languages[i].slug];        
      }
      this.newScaleDeclaration = [];
      for(var i = 0; i < this.languages; i++){
        this.newScaleDeclaration[this.languages[i].slug];        
      }
    },
    
    toggle(action, item_id, editing, attributes) {
      this.active = true;
      this.action = action;
      this.editing = editing;
      
      let dataRoute = decodeURI(attributes.dataRoute);
      if (dataRoute !== undefined) {
        if (dataRoute.indexOf("[id]") > 0) {
          dataRoute = dataRoute.replace("[id]", item_id);
        }        
        axios.get(dataRoute).then((response) => {          
          this.name = response.data.base.name;
          this.description = response.data.base.description;
          this.sorting = response.data.base.sorting;
          this.calculation = response.data.calculation;
          this.rating = response.data.rating;
          this.scale = response.data.scale;
          this.categoriesProposals = response.data.categories;
          this.showing_results = response.data.showing_results;
          this.final_rating = response.data.final_rating;
          this.allCategories = response.data.allCategories;
          this.showDynamicLevelFactorNote = response.data.showDynamicLevelFactorNote;
          this.include_zero_value_in_operation = response.data.include_zero_value_in_operation;          
          this.actualSlugLang = response.data.actualSlugLang;
          this.languages = response.data.languages;      
          this.can_write = app.__vue__.questionPermission(this.can_write,response.data.base.enable);
          
          //EXPECTED VALUE
          this.enable_expected_value = response.data.enable_expected_value;
          this.expected_value = response.data.expected_value;
        });
      }
    },
  },
};
</script>
